<template lang="pug">
.container.solicitarDireito
  .card
    cadastro-sicarf(
      titleCadastro="Solicitar transferência de direitos",
      routeName="transferenciaDireito",
      :cadastroEmpty="empty",
      :tabs="tabs",
    )
</template>
<script>
import empty from '../empty/emptyTransferenciaDireito'
import CadastroSicarf from '@/screens/central/components/CadastroSicarf'

export default {

  components: {
    CadastroSicarf
  },

  data () {
    return {
      // O atributo @name deve ser o mesmo da rota definida no router
      tabs: [
        {
          label: 'Cadastrante',
          name: 'transferenciaDireito/cadastrante'
        },
        {
          label: 'Interessado',
          name: 'transferenciaDireito/interessado'
        },
        {
          label: 'Imóvel',
          name: 'transferenciaDireito/imovel'
        },
        {
          label: 'Georreferenciamento',
          name: 'transferenciaDireito/georreferenciamento'
        },
        {
          label: 'Resumo',
          name: 'transferenciaDireito/resumo',
          isResumo: true
        }
      ],
      empty: empty
    }
  }

}
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  .card {
    width: 100%;
  }
}

@media (max-width: 780px) {
  .solicitarDireito {
    position: relative;
    top: 50px;
    right: 130px;
    width: 350px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/transferenciaDireito/Cadastro.vue